import { useCopy } from "../../utils/globalContext";
import { Body, Card, cx, styled } from "@kivra/react-components";
import { AlertFilledIcon } from "@kivra/react-components/icons";

export const SessionEndedError = () => {
  const copy = useCopy();

  return (
    <MessageContent className={cx(Card.Variant.Raised, Card.Size.Small)}>
      <div>
        <AlertFilledIcon
          size={24}
          colorToken={"$on-surface-error-light"}
        />
      </div>

      <TextContent>
        <Body color="$text-primary" size="medium">
          {copy("auth_session_ended_message")}
        </Body>
      </TextContent>
    </MessageContent>
  );
};

const MessageContent = styled("div")({
  display: "flex",
  gap: "$spacing-12",
  marginTop: "$spacing-32",
  background: "$surface-error-light",
  alignItems: "center",
});

const TextContent = styled("div")({
  display: "grid",
  gridGap: "$spacing-4",
  maxWidth: "720px",
});
